import { whiteLabelServices } from "./white-label";

export const assetServices = {
  whiteLabelServices
};